import { UserSource } from 'common-types';
import { SUBSCRIPTION_VARIANT } from 'pages/renew-subscription-landing/components/payment/utils/types';
import { StateCreator } from 'zustand';

import { IUserStore } from './types';

export const userSlice: StateCreator<IUserStore, [], [], IUserStore> = (set) => ({
  email: '',
  isSessionInitialized: false,
  guideType: null,
  isDrawerDialogOpen: false,
  photo: '',
  isModalOpened: false,
  isResetPasswordModalOpened: false,
  userStatus: '',
  partView: null,
  userGoal: '',
  ultimateWhy: '',
  paymentRef: null,
  isPasswordChangeModalOpened: false,
  isUserWithVat: false,
  activePaymentCard: SUBSCRIPTION_VARIANT.MONTHLY_PREMIUM,
  subscriptionUserSource: UserSource.WEB,
  restoredStyleSession: null,
  isReviewModalOpen: false,
  reviewModalPlacement: null,
  reviewModalDay: null,
  isOpenPaymentModal: false,
  unsubscribeSource: null,
  isUserHasMembership: false,
  setUnsubscribeSource: (unsubscribeSource) => set({ unsubscribeSource }),
  setIsOpenPaymentModal: (isOpenPaymentModal: boolean) => set({ isOpenPaymentModal }),
  setRestoredStyleSession: (restoredStyleSession) => set({ restoredStyleSession }),
  setSubscriptionUserSource: (subscriptionUserSource) => set({ subscriptionUserSource }),
  setActivePaymentCard: (activePaymentCard) => set({ activePaymentCard }),
  setEmail: (email) => set({ email }),
  setIsSessionInitialized: (isSessionInitialized) => set({ isSessionInitialized }),
  setGuideType: (guideType) => set({ guideType }),
  setIsDrawerDialogOpen: (isDrawerDialogOpen) => set({ isDrawerDialogOpen }),
  setPhoto: (photo) => set({ photo }),
  setIsModalOpened: (isModalOpened) => set({ isModalOpened }),
  setIsResetPasswordModalOpened: (isResetPasswordModalOpened) => set({ isResetPasswordModalOpened }),
  setUserStatus: (userStatus) => set({ userStatus }),
  setPartView: (partView) => set({ partView }),
  setUserGoal: (userGoal) => set({ userGoal }),
  setUltimateWhy: (ultimateWhy) => set({ ultimateWhy }),
  setPaymentRef: (paymentRef) => set({ paymentRef }),
  setIsPasswordChangeModalOpened: (isPasswordChangeModalOpened) => set({ isPasswordChangeModalOpened }),
  setIsUserWithVat: (isUserWithVat) => set({ isUserWithVat }),
  setIsReviewModalOpen: (isReviewModalOpen, placement, day) =>
    set({ isReviewModalOpen, reviewModalPlacement: placement ?? null, reviewModalDay: day ?? null }),
  setIsUserHasMembership: (isUserHasMembership) => set({ isUserHasMembership }),
});
